import { useRef, useCallback } from 'react'; 
//FP-12575 Debounce save for UI actions
export function usePromiseDebounce<T extends (...args: any[]) => Promise<any>>(callback: T) {
    const pending = useRef<Promise<any> | null>(null);

    return useCallback(async (...args: Parameters<T>) => {
        if (pending.current) {
            await pending.current;
        }
        pending.current = callback(...args);
        try {
            await pending.current;
        } finally {
            pending.current = null;
        }
    }, [callback]);
}
